module.exports = __webpack_public_path__ + "static/media/cate-home.f6e1406f.png";